module.exports = __webpack_public_path__ + "static/img/bg@2x.ffcc959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bg@2x.png
// module id = MVla
// module chunks = 70